// extracted by mini-css-extract-plugin
export default {"content-right":"ContentRight_content-right__qDrCk","item":"ContentRight_item__B-ara","content-hot":"ContentRight_content-hot__7BUM6"};